// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"kh","product":"lh","products":"mh","tooltipWrapper":"nh","tooltip":"oh","title":"ph","secondRow":"qh","firstRow":"rh"};